/*
 * Module for the ETL - Member Account and Service Summary criteria page
 */
rs.module("content/jobs/criteria/etlmemberaccountandservicesummary",

    [],

    function () {

        // Initialize the page
        function initialize(jsSelectors) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);
            var incrementalRunCheckbox = criteria.js(jsSelectors.incrementalRunCheckbox);
            var reCalculateServiceCheckbox = criteria.js(jsSelectors.reCalculateServiceCheckbox);

            // toggle the Re-Calculate Service checkbox
            incrementalRunCheckbox.change(function () {
                reCalculateServiceCheckbox[0].checked = false;
                reCalculateServiceCheckbox.prop("disabled", !incrementalRunCheckbox.is(":checked"));
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);